import React, { createContext, useState, useEffect } from "react"
import { useAuth0 } from "@auth0/auth0-react"

export const AuthContext = createContext()

export const AuthProvider = ({ children }) => {
  const { isAuthenticated, isLoading, loginWithRedirect, logout, user } =
    useAuth0()
  const [authState, setAuthState] = useState({
    isAuthenticated: false,
    isLoading: true,
    user: null,
  })

  useEffect(() => {
    setAuthState({
      isAuthenticated,
      isLoading,
      user,
      logout,
    })
  }, [isAuthenticated, isLoading, user])

  return (
    <AuthContext.Provider value={authState}>{children}</AuthContext.Provider>
  )
}
